export enum PagingVariables {
	DefaultPageSize = 20,
}
